import { Component, OnInit, NgZone } from '@angular/core';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import { AppDataServiceService } from 'src/app/app-data-service.service';

@Component({
  selector: 'app-right-aside-energy',
  templateUrl: './right-aside-energy.component.html',
  styleUrls: ['./right-aside-energy.component.css']
})
export class RightAsideEnergyComponent implements OnInit {
  private chart: am4charts.XYChart;
  
  constructor(private zone: NgZone,private _getLiveDataForCharts:AppDataServiceService) {}

  ngOnInit() {
    this.getliveChartsData();
  }

    
  ngOnDestroy() {
    this.zone.runOutsideAngular(() => {
      if (this.chart) {
        this.chart.dispose();
      }
    });
  }

  getliveChartsData(){
    this._getLiveDataForCharts.getLiveData().subscribe(
      data=> this.liveChartsData(data),
      error=>console.error(error)
     );
  }
  liveChartsData(data){
    //this.date = data.data.date
    this.liveGridConsumption(data.data.pichart.grid);
    this.liveUtilisation(data.data.pichart.utilisation);
    this.HourlyEnergyConsumption(data.data.linechart.grid);
  
  }


  HourlyEnergyConsumption(data){
      console.log('hourly data live ',data)
      let title_text =  `Hourly Energy Cunsumption of ${data[0].lable} for Date : ${data[0].date}`
      this.zone.runOutsideAngular(() => {
      let chart = am4core.create("lineChart", am4charts.XYChart);
      ///chart.paddingRight = 20;

      let title = chart.titles.create();
      title.text = title_text;
      title.fontSize = 14;
      title.marginBottom = 10;

      chart.data = data;
      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "hour";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.fontSize = 10;
        
        //categoryAxis.renderer.labels.template.rotation = 90;
        categoryAxis.tooltip.disabled = true;
      //let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      /*let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      dateAxis.renderer.grid.template.location = 0;*/

      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.tooltip.disabled = true;
      valueAxis.fontSize = 10;
      //valueAxis.title = " Hejdfhd";

      let series = chart.series.push(new am4charts.LineSeries());
      series.dataFields.categoryX = "hour";
      series.dataFields.valueY = "todays_energy";
      series.tooltipText = "Energy: [bold]{valueY}[/]";
      series.fillOpacity = 0.3;
      series.stroke = am4core.color("red")
      series.strokeWidth = 2;
      series.fillOpacity = 1;
      series.fill = am4core.color("red");

      var fillModifier = new am4core.LinearGradientModifier();
      fillModifier.opacities = [1, 0];
      fillModifier.offsets = [0, 1];
      fillModifier.gradient.rotation = 90;
      series.segments.template.fillModifier = fillModifier;

      series.tensionX = 0.7;
     
     
      series.tooltipText = "{categoryX} : {valueY.value}";
      chart.cursor = new am4charts.XYCursor();
      var markerTemplate = chart.legend.markers.template;
      markerTemplate.width = 14;
      markerTemplate.height = 14;
      //this.chart = chart;
    });

  }
  liveUtilisation(data){
     let chart = am4core.create("pieUTILISATION", am4charts.PieChart);
      chart.data = data;
      /*let pieSeriesChart = charts.series.push(new am4charts.PieSeries());
      pieSeriesChart.dataFields.value = "todays_energy";
      pieSeriesChart.dataFields.category = "lable";
      pieSeriesChart.slices.template.stroke = am4core.color("#4a2abb");
      pieSeriesChart.slices.template.strokeWidth = 2;
      pieSeriesChart.slices.template.strokeOpacity = 1;
      pieSeriesChart.slices.template.tooltipText = "";*/

      // Add and configure Series
      var pieSeries = chart.series.push(new am4charts.PieSeries());
      //pieSeries.radius = am4core.percent(90);
      //pieSeries.labels.template.radius = am4core.percent(10);
      pieSeries.dataFields.value = "todays_energy";
      pieSeries.dataFields.category = "lable";
      pieSeries.labels.template.disabled = true;
      pieSeries.slices.template.cornerRadius = 3;
      pieSeries.slices.template.innerCornerRadius = 2;
      
      pieSeries.ticks.template.disabled = true;

      chart.legend = new am4charts.Legend();
      chart.legend.position = "right";
      chart.legend.fontSize = 10;
      chart.legend.itemContainers.template.paddingTop = 0
      chart.legend.itemContainers.template.paddingBottom = 0
      chart.legend.itemContainers.template.paddingRight = 0
      chart.legend.itemContainers.template.resizable = true;
      let markerTemplate = chart.legend.markers.template;
      markerTemplate.width = 10;
      markerTemplate.height = 10;
      
      chart.innerRadius = am4core.percent(60);
      chart.radius = am4core.percent(80);

      var label = pieSeries.createChild(am4core.Label);
      label.text = "Total \n {values.value.sum}";
      label.horizontalCenter = "middle";
      label.verticalCenter = "middle";
      label.fontSize = 14;
      
  }
  liveGridConsumption(data){
      let chart = am4core.create("pieGRID", am4charts.PieChart);
      chart.data = data;
      /*let pieSeriesChart = charts.series.push(new am4charts.PieSeries());
      pieSeriesChart.dataFields.value = "todays_energy";
      pieSeriesChart.dataFields.category = "lable";
      pieSeriesChart.slices.template.stroke = am4core.color("#4a2abb");
      pieSeriesChart.slices.template.strokeWidth = 2;
      pieSeriesChart.slices.template.strokeOpacity = 1;
      pieSeriesChart.slices.template.tooltipText = "";*/


      var pieSeries = chart.series.push(new am4charts.PieSeries());
      //pieSeries.radius = am4core.percent(90);
      //pieSeries.labels.template.radius = am4core.percent(10);
      pieSeries.dataFields.value = "todays_energy";
      pieSeries.dataFields.category = "lable";
      pieSeries.labels.template.disabled = true;
      pieSeries.slices.template.cornerRadius = 3;
      pieSeries.slices.template.innerCornerRadius = 2;
      
      pieSeries.ticks.template.disabled = true;

      chart.legend = new am4charts.Legend();
      chart.legend.position = "right";
      chart.legend.fontSize = 10;
      chart.legend.itemContainers.template.paddingTop = 0
      chart.legend.itemContainers.template.paddingBottom = 2
      chart.legend.itemContainers.template.paddingRight = 2
      chart.legend.itemContainers.template.resizable = true;
      let markerTemplate = chart.legend.markers.template;
      markerTemplate.width = 10;
      markerTemplate.height = 10;
      
      chart.innerRadius = am4core.percent(60);
      chart.radius = am4core.percent(80);

      var label = pieSeries.createChild(am4core.Label);
      label.text = "Total \n{values.value.sum}";
      label.horizontalCenter = "middle";
      label.verticalCenter = "middle";
      label.fontSize = 14;
          }
 }

